// import React, { useState } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import '../Styles/Register.css';

// function Register({ darkMode }) {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [error, setError] = useState('');

//   function handleRegister(e) {
//     e.preventDefault();

//     // Basic validation
//     if (!email || !password || !confirmPassword) {
//       setError('Please fill all fields');
//       return;
//     }
//     if (password !== confirmPassword) {
//       setError('Passwords do not match');
//       return;
//     }

//     setError('');

//     // TODO: Add Firebase or backend registration logic here
//     console.log('Registering user:', email, password);

//     // After registration, navigate to features page
//     navigate('/features');
//   }

//   return React.createElement(
//     'div',
//     { className: `register-container ${darkMode ? 'dark' : 'light'}` },
//     React.createElement(
//       'div',
//       { className: 'register-card' },
//       React.createElement('h2', null, 'Create Account'),
//       error && React.createElement('p', { className: 'error' }, error),
//       React.createElement(
//         'form',
//         { onSubmit: handleRegister },
//         React.createElement('input', {
//           type: 'email',
//           placeholder: 'Email',
//           value: email,
//           onChange: (e) => setEmail(e.target.value),
//         }),
//         React.createElement('input', {
//           type: 'password',
//           placeholder: 'Password',
//           value: password,
//           onChange: (e) => setPassword(e.target.value),
//         }),
//         React.createElement('input', {
//           type: 'password',
//           placeholder: 'Confirm Password',
//           value: confirmPassword,
//           onChange: (e) => setConfirmPassword(e.target.value),
//         }),
//         React.createElement(
//           'button',
//           { type: 'submit', className: 'register-btn' },
//           'Sign Up'
//         )
//       ),
//       React.createElement(
//         'p',
//         null,
//         'Already have an account? ',
//         React.createElement(Link, { to: '/login' }, 'Log In')
//       )
//     )
//   );
// }

// export default Register;

import React, { useState } from 'react';
import '../Styles/Register.css';

function Register() {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!username.trim()) {
      alert('Please enter your GitHub username');
      return;
    }

    setIsLoading(true);
    
    // Store username
    localStorage.setItem('wolfbot_github_username', username);
    
    // Redirect to Heroku
    setTimeout(() => {
      window.location.href = `https://heroku.com/deploy?template=https://github.com/777Wolf-dot/Silent-Wolf--Bot.git`;
    }, 1000);
  };

  // Create particles effect
  React.useEffect(() => {
    const createParticles = () => {
      const particlesContainer = document.getElementById('particles');
      if (!particlesContainer) return;
      
      const particleCount = Math.min(30, Math.floor(window.innerWidth / 25));
      particlesContainer.innerHTML = '';
      
      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        
        const x = Math.random() * 100;
        const y = Math.random() * 100;
        particle.style.left = `${x}%`;
        particle.style.top = `${y}%`;
        
        const size = 3 + Math.random() * 5;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.opacity = 0.1 + Math.random() * 0.4;
        
        const delay = Math.random() * 20;
        const duration = 15 + Math.random() * 25;
        particle.style.animationDelay = `${delay}s`;
        particle.style.animationDuration = `${duration}s`;
        
        particlesContainer.appendChild(particle);
      }
    };

    createParticles();
    window.addEventListener('resize', createParticles);
    
    return () => window.removeEventListener('resize', createParticles);
  }, []);

  return (
    <div className="container">
      <div id="particles"></div>
      
      <div className="header">
        <div className="wolf-icon">
          <i className="fas fa-paw"></i>
        </div>
        <h1><b> Wolf Bot</b></h1>
        <p className="subtitle">
          A powerful, feature-rich Discord bot with advanced moderation tools, 
          entertainment features, and seamless integration. Deploy in minutes.
        </p>
      </div>
      
      <div className="deploy-card">
        <div className="card-header">
          <h2>Deploy to Heroku</h2>
          <p>Enter your GitHub username to start the deployment process</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="githubUsername">
              <i className="fas fa-user"></i> GitHub Username
            </label>
            <div className="input-wrapper">
              <input 
                type="text" 
                id="githubUsername" 
                placeholder="Enter your GitHub username..."
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <div className="github-icon">
                <i className="fab fa-github"></i>
              </div>
            </div>
          </div>
          
          <button type="submit" className="deploy-button" disabled={isLoading}>
            <i className={`fab fa-heroku heroku-icon ${isLoading ? 'fa-spin' : ''}`}></i>
            {isLoading ? 'Redirecting to Heroku...' : 'Deploy  Wolf Bot to Heroku'}
          </button>
        </form>
        
        <p className="info-text">
          After submitting, you'll be redirected to Heroku to complete the deployment process.
          Make sure you have a Heroku account and are logged in. The deployment typically takes 2-3 minutes.
        </p>
      </div>
      
      {/* Rest of your JSX components for features, steps, footer */}
    </div>
  );
}

export default Register;